// Numbers are stored plain (digits only). These helpers are for display only.
export function formatPhone(value) {
  const d = String(value || "").replace(/\D/g, "");
  if (!d) return "";
  let local = d;
  if (local.startsWith("61") && local.length >= 11) local = `0${local.slice(2)}`;
  if (local.length === 9 && /^[45]/.test(local)) local = `0${local}`;
  if (local.length === 10 && local.startsWith("04")) {
    return `${local.slice(0, 4)} ${local.slice(4, 7)} ${local.slice(7)}`;
  }
  if (local.length === 10 && local.startsWith("0")) {
    return `(${local.slice(0, 2)}) ${local.slice(2, 6)} ${local.slice(6)}`;
  }
  if (local.length === 8) return `${local.slice(0, 4)} ${local.slice(4)}`;
  return value;
}
